import { BACKEND_ENV_HEADER } from '@/utils/appEnv';
import { fetchJSON, postSSE, type SSEEventCallback } from '@/utils/streamAI';

import type { ChatHistoryResponse, NonStreamResponse } from './equipment-ai-chat.types';

const base = () => `${import.meta.env.VITE_APP_EXTRACT_URL}/api/ai/vessel/equipment/chat`;

export { AIFetchError } from '@/utils/streamAI';

export function streamEquipmentChat(
  vessel_id: string,
  user_id: string,
  message: string,
  onEvent: SSEEventCallback,
  signal?: AbortSignal,
): Promise<void> {
  return postSSE(`${base()}/stream`, { vessel_id, user_id, message }, onEvent, signal);
}

export function chatEquipment(
  vessel_id: string,
  user_id: string,
  message: string,
  signal?: AbortSignal,
): Promise<NonStreamResponse> {
  return fetchJSON<NonStreamResponse>(base(), {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ vessel_id, user_id, message }),
    signal,
  });
}

export function getEquipmentChatHistory(
  vessel_id: string,
  user_id: string,
): Promise<ChatHistoryResponse> {
  const params = new URLSearchParams({ vessel_id, user_id });
  return fetchJSON<ChatHistoryResponse>(`${base()}/history?${params.toString()}`);
}

export async function deleteEquipmentChatHistory(
  vessel_id: string,
  user_id: string,
): Promise<void> {
  const params = new URLSearchParams({ vessel_id, user_id });
  const response = await fetch(`${base()}/history?${params.toString()}`, {
    method: 'DELETE',
    headers: BACKEND_ENV_HEADER,
  });
  // 204 No Content is the expected success; response.ok covers it (200–299)
  if (!response.ok) {
    throw new Error(`Clear chat failed: ${response.status.toString()}`);
  }
}
